import { GetStaticProps } from 'next';
import { PostsOrPages } from '@tryghost/content-api';

import { Hero } from '@/components/common';
import Ghost from '@/services/ghost';
import BlogCard from '@/components/blog-card';

export interface BlogPageProps {
  posts: PostsOrPages;
}

export default function BlogPage({ posts }: BlogPageProps) {
  return (
    <div>
      <Hero title="BLOGS" />

      <section className="px-6 md:px-8 py-12 space-y-6 md:space-y-20 bg-gray-50">
        <div className="grid gap-6 xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3  max-w-6xl mx-auto">
          {posts.map((el) => (
            <BlogCard blog={el} key={el.slug} />
          ))}
        </div>
      </section>
    </div>
  );
}

export const getStaticProps: GetStaticProps<BlogPageProps> = async (
  context
) => {
  console.log(context);
  const posts = await Ghost.posts.browse({
    limit: 'all',
    include: ['authors'],
    filter: ['tag:blog', `tag:blog-${context.locale}`],
    order: 'published_at desc',
  });
  return {
    props: { posts },
    revalidate: 10,
  };
};
